import { render } from "./ComparisonTable.vue?vue&type=template&id=19537464&scoped=true"
import script from "./ComparisonTable.vue?vue&type=script&lang=js"
export * from "./ComparisonTable.vue?vue&type=script&lang=js"

import "./ComparisonTable.vue?vue&type=style&index=0&id=19537464&scoped=true&lang=css"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19537464"]])

export default __exports__